export default {
  NUTRITIONNEXTSTEP (state, payload) {
    if (payload !== undefined) {
      state.surveyStep = payload + 1
    } else {
      state.surveyStep = state.surveyStep + 1
    }
  },
  NUTRITIONPREVIOUSSTEP (state, payload) {
    state.surveyStep = state.surveyStep - 1
  },
  NUTRITIONSURVEYERRORS (state, payload) {
    state.onboard = false
  },
  RESTARTNUTRITIONSURVEY (state, payload) {
    state.surveyStep = 0
  },
  SETACTIVESURVEY (state, payload) {
    state.activeSurvey = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/surveys/mutations.js